import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, getApiBase } from "../api";
import Shell from "../components/Shell";

const APP_IMAGES = {
  cel: "/apps/card-cel.svg",
  tv: "/apps/card-tv.svg",
};

function formatBytes(bytes) {
  if (!bytes) return "—";
  const units = ["B", "KB", "MB", "GB"];
  let size = bytes;
  let i = 0;
  while (size >= 1024 && i < units.length - 1) {
    size /= 1024;
    i += 1;
  }
  return `${size.toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}

function AppReleaseCard({ release }) {
  const downloadHref = release.available
    ? `${getApiBase()}${release.download_url}`
    : null;
  const image = APP_IMAGES[release.id] || APP_IMAGES.cel;

  return (
    <article className={`apps-card apps-card-${release.icon}`}>
      <div className="apps-card-visual">
        <img src={image} alt="" className="apps-card-image" loading="lazy" />
        <div className="apps-card-badge">{release.tagline}</div>
      </div>
      <div className="apps-card-body">
        <h2>{release.name}</h2>
        <p className="apps-card-desc">{release.description}</p>
        <dl className="apps-card-meta">
          <div>
            <dt>Versión</dt>
            <dd>{release.version}</dd>
          </div>
          <div>
            <dt>Tamaño</dt>
            <dd>{formatBytes(release.size_bytes)}</dd>
          </div>
          <div>
            <dt>Paquete</dt>
            <dd>{release.package_id}</dd>
          </div>
        </dl>
        {release.available ? (
          <a href={downloadHref} className="apps-download-btn" download={release.filename}>
            Descargar APK
          </a>
        ) : (
          <p className="apps-unavailable">APK no disponible en el servidor.</p>
        )}
      </div>
    </article>
  );
}

export default function AppsDownloadPage() {
  const [releases, setReleases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    api("/api/apps/releases")
      .then((data) => {
        if (!cancelled) setReleases(data.releases || []);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || "No se pudo cargar la información");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Shell wide>
      <div className="apps-page">
        <section className="apps-hero">
          <div className="apps-hero-bg" aria-hidden="true">
            <div className="apps-hero-orb apps-hero-orb-a" />
            <div className="apps-hero-orb apps-hero-orb-b" />
          </div>
          <img
            src="/apps/hero-devices.svg"
            alt=""
            className="apps-hero-devices-img"
            aria-hidden="true"
          />
          <div className="apps-hero-content">
            <p className="apps-hero-kicker">Apps oficiales · Android</p>
            <h1>CasaStream en tus dispositivos</h1>
            <p className="apps-hero-lead">
              Instala la app en tu celular o televisor Android. Mismo catálogo, perfiles Kids
              y acceso desde internet en <strong>app.romdevs.com</strong>.
            </p>
            <Link to="/" className="apps-back-link">
              ← Volver al inicio
            </Link>
          </div>
        </section>

        <section className="apps-grid-section">
          {loading ? <p className="muted apps-status">Cargando apps…</p> : null}
          {!loading && error ? <p className="apps-status apps-error">{error}</p> : null}
          {!loading && !error ? (
            <div className="apps-grid">
              {releases.map((release) => (
                <AppReleaseCard key={release.id} release={release} />
              ))}
            </div>
          ) : null}
        </section>

        <section className="apps-steps">
          <div className="apps-steps-visual">
            <img src="/apps/hero-devices.svg" alt="" loading="lazy" />
          </div>
          <div className="apps-steps-copy">
            <h2>Cómo instalar</h2>
            <ol className="apps-steps-list">
              <li>
                <strong>Descarga</strong> el APK que corresponda a tu dispositivo.
              </li>
              <li>
                En Android, activa <em>Instalar apps desconocidas</em> para tu navegador.
              </li>
              <li>Abre el archivo descargado y confirma la instalación.</li>
              <li>Inicia sesión con tu usuario de Casasm y elige tu perfil.</li>
            </ol>
            <p className="apps-steps-note muted">
              Las apps se conectan a <strong>api.romdevs.com</strong> (no uses app.romdevs.com en
              la app). Funciona en casa y fuera de tu red WiFi.
            </p>
          </div>
        </section>
      </div>
    </Shell>
  );
}
